export default __webpack_public_path__ + "static/media/1931.4ac3d6cb.png";